import { Component } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-bi-transfers',
  templateUrl: './bi-transfers.component.html',
  styleUrls: ['./bi-transfers.component.scss']
})
export class BiTransfersComponent {

  permissionType = PermissionTypeEnum;
  history = 0;

  constructor(
    private authService: AuthenticationService,

  )
  {
    var permissions = authService.getPermissions();
  }

  

}
